import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { ReferAFriendLabels } from './refer-a-friend-labels.model';
import { map } from 'rxjs/operators';

export const REFER_A_FRIEND_ACCEPT_VERSION = '1.0.0';

@Injectable()
export class ReferAFriendDataService {
  private _referAFriendUrl = '/refer_a_friend';

  protected referAFriendHeaders: any = {
    [ACCEPT_VERSION_HEADER]: REFER_A_FRIEND_ACCEPT_VERSION,
  };

  constructor(private _authHttpService: AuthHttpService) {}

  fetchLabels(): Observable<ReferAFriendLabels> {
    return this._authHttpService
      .get(this._referAFriendUrl, {}, this.referAFriendHeaders)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new ReferAFriendLabels(body['refer_a_friend']['labels'])
        )
      );
  }

  sendEmail(email: string): Observable<IResponseInfo> {
    const url = `${this._referAFriendUrl}/send_invite`;
    const body = {
      email,
    };

    return this._authHttpService.post(url, body, this.referAFriendHeaders);
  }
}
